/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Admin_1Inputs */

const da_privacy_admin_1 = /** @type {(inputs: Privacy_Admin_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vores administratorer kan se konti, organisationer, medlemmer, forbrug, betalinger, betaanmodninger og det, du selv har skrevet under Om dig. Det bruger vi til drift og support og til at kontakte dem, der har sagt ja til at give feedback.`)
};

/** @type {(inputs: Privacy_Admin_1Inputs) => LocalizedString} */
const en_privacy_admin_1 = da_privacy_admin_1;

/**

* @param {Privacy_Admin_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_admin_1 = /** @type {((inputs?: Privacy_Admin_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Admin_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_admin_1(inputs)
	return /** @type {LocalizedString} */ ("Vores administratorer kan se konti, organisationer, medlemmer, forbrug, betalinger, betaanmodninger og det, du selv har skrevet under Om dig. Det bruger vi til drift og support og til at kontakte dem, der har sagt ja til at give feedback.")
});